import { render, staticRenderFns } from "./PrinterListBody.vue?vue&type=template&id=68cd3cce"
import script from "./PrinterListBody.vue?vue&type=script&lang=ts"
export * from "./PrinterListBody.vue?vue&type=script&lang=ts"
import style0 from "./PrinterListBody.scss?vue&type=style&index=0&prod&lang=scss&module=true&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports